import { View, FlatList, Text, Platform } from 'react-native'
import { styles } from './Observers.styles'
import { useStore } from '../../../../../models'
import { ObserverItem } from './Partial/ObserverItem'
import { BottomSheetView } from '@gorhom/bottom-sheet'

export type ObserversProps = {
  title?: string
}

export const Observers = ({ title = 'OBSERVERS' }: ObserversProps) => {
  const {
    game: { nonSeatedObservers: observers }
  } = useStore()
  return (
    <BottomSheetView style={[styles.container, Platform.OS !== 'web' ? { flex: 1 } : { flex: undefined }]}>
      <Text style={styles.observerText}>{title}</Text>
      <FlatList
        contentContainerStyle={{ paddingBottom: 24 }}
        data={observers}
        renderItem={({ index, item }) => <ObserverItem player={item} index={index} />}
      />
    </BottomSheetView>
  )
}
